var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"backgroundColor",attrs:{"height":_vm.$vuetify.breakpoint.mdAndUp ? "100%" : "100vmax"}},[_c('div',{staticClass:"Welcometitle primary--text titleFontlg"},[_vm._v(" Modification de compte ")]),_c('MyInfo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }